const customCursor = () => {
    const classes = {
        customCursorVisible: 'custom-cursor--visible',
    };
    const selectors = {
        customCursor: '[data-custom-cursor]',
        links: '[href]',
        button: 'button',
        roleButton: '[role="button"]',
        btn: '.btn',
    };
    const cursorDot = document.querySelector(selectors.customCursor);
    const events = ['scroll', 'mousemove'];
    const cursorVisibility = (element) => {
        element.addEventListener('mouseenter', () => {
            cursorDot.classList.add(classes.customCursorVisible);
        });
        element.addEventListener('mouseleave', () => {
            cursorDot.classList.remove(classes.customCursorVisible);
        });
    };
    const getElements = () => {
        const customCursorElements = document.querySelectorAll(`${selectors.links}, ${selectors.button}, ${selectors.roleButton}, ${selectors.btn}`);
        customCursorElements.forEach((element) => {
            cursorVisibility(element);
        });
    };
    if (cursorDot) {
        events.forEach((event) => {
            window.addEventListener(event, (e) => {
                document.documentElement.style.setProperty('--mouse-x', e.pageX + 'px');
                document.documentElement.style.setProperty('--mouse-y', e.pageY + 'px');
            });
        });
        getElements();
    }
};
export { customCursor };
